export default __webpack_public_path__ + "static/media/vp2_img.d06731d0.jpg";